import styled from 'styled-components';

export const StyledCarousel = styled.div`
    display: flex;
    will-change: transform;
`;

StyledCarousel.displayName = 'StyledBox';
